module.exports = __webpack_public_path__ + "media/quit.44500d07.mp3";